import {CTP_BADGES_REDESIGN_IDS} from './constants';
import {CtpBadgeValueType} from './types';

/**
 * Type-guard to check if id is a part of ctp badges
 */
export const getIsBadgeIdValid = (id: string | number): id is CtpBadgeValueType => {
    if (typeof id === 'string') return false;
    return CTP_BADGES_REDESIGN_IDS.includes(id as CtpBadgeValueType);
};
